import io from 'socket.io-client'

import config from './config'

import Auth from './stores/Auth'
import Ticket from './stores/Ticket'

class WS {
  init() {
    this.io = io(`${config.api_uri}/`, {
      path: `/ws/`,
      query: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })

    this.io.on('connect', this.onSocketConnected.bind(this))
  }

  onSocketConnected() {
    this.io.on('ticket.created', data => {
      Ticket.insertLocalTicket(data)
    })

    this.io.on('ticket.updated', data => {
      Ticket.updateLocalTicket(data)
    })

    this.io.on('ticket.response.created', data => {
      Ticket.insertLocalResponse(data)
    })
  }
}

export default new WS()



// WEBPACK FOOTER //
// ./src/ws.js